module.exports = __webpack_public_path__ + "img/4.e3d931f6.jpg";